<template>
  <div v-if="shouldDisplay">
    <span class="tw-font-bold tw-text-sf-slate">{{ currentIndex + 1 }}</span>
    <span class="tw-text-sf-slate-light-1">{{ ` / ${total}` }}</span>
  </div>
</template>

<script>
export default {
  props: {
    currentIndex: {
      type: Number,
    },
    total: {
      type: Number,
    },
    showEmpty: {
      type: Boolean,
    },
  },
  computed: {
    shouldDisplay() {
      return this.total > 0 || this.showEmpty
    },
  },
}
</script>
